import * as React from "react";
import classNames from "classnames";
import Icons from "../../JobPage/components/Icons";

interface IProps {
    title?: string,
    disabled?: boolean,
    focus?(): void,
}

export default class FocusIcon extends React.PureComponent<IProps> {
    handleClick = () => {
        if (!this.props.disabled && this.props.focus) {
            this.props.focus();
        }
    }
    render() {
        return <span
            className={classNames('ll-focus-icon', { 'll-disabled': this.props.disabled })}
            title={this.props.title}
            onClick={this.handleClick}
        >{Icons.searchPlus}</span>
    }
}
